import React from 'react';

function RatingItem(props) {
  return (
    <div className="rating-item">
      <div className="rating-circle">
        <div
          className={
            'c100  small ' +
            ('p' + ((+props.rating / 5) * 100).toFixed(0)) +
            ' ' +
            ((+props.rating / 5) * 100 < 30
              ? 'red'
              : (+props.rating / 5) * 100 < 50
              ? 'yellow'
              : (+props.rating / 5) * 100 < 80
              ? 'orange'
              : 'green')
          }
        >
          <span className> {props.rating} </span>
          <div className="slice">
            <div className="bar"> </div> <div className="fill"> </div>
          </div>
        </div>
      </div>
      <div className="text font10"> {props.label} </div>
    </div>
  );
}

export default RatingItem;



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusServiceList/ServiceItem/components/RatingItem.js